import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Icon, Loader } from "semantic-ui-react";
import { map, size } from "lodash";
import { useCustomer } from "../../../hooks";
import { CustomerForm } from "./CustomerForm";
import "./Customers.scss";

// "Selecciona un cliente": buscar, elegir, crear o editar — como el de
// Restaurant.pe. Sin `onSelect` sirve solo para administrar la lista.
export function CustomerPickerModal(props) {
  const { show, onClose, onSelect } = props;
  const { getCustomers } = useCustomer();
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState(null);
  const [editing, setEditing] = useState(null); // null = lista; {} = nuevo; cliente = editar

  useEffect(() => {
    if (!show) return undefined;
    setEditing(null);
    const timeout = setTimeout(async () => {
      try {
        setCustomers(await getCustomers(search));
      } catch (error) {
        setCustomers([]);
      }
    }, 250); // espera a que termine de escribir
    return () => clearTimeout(timeout);
  }, [show, search]);

  const onSaved = (customer) => {
    if (onSelect) onSelect(customer);
    else {
      setEditing(null);
      getCustomers(search).then(setCustomers).catch(() => {});
    }
  };

  const title = editing ? (editing.id ? "Editar cliente" : "Nuevo cliente") : "Selecciona un cliente";

  return (
    <Modal open={show} onClose={onClose} size="small" closeIcon className="customer-picker">
      <Modal.Header>
        <Icon name="user outline" /> {title}
      </Modal.Header>
      <Modal.Content scrolling>
        {editing ? (
          <CustomerForm
            customer={editing.id ? editing : null}
            onSaved={onSaved}
            onCancel={() => setEditing(null)}
          />
        ) : (
          <>
            <div className="customer-picker__toolbar">
              <Input
                icon="search"
                iconPosition="left"
                placeholder="Buscar por nombre, teléfono o documento"
                value={search}
                onChange={(_, data) => setSearch(data.value)}
              />
              <Button primary onClick={() => setEditing({})}>
                <Icon name="add user" /> Crear nuevo cliente
              </Button>
            </div>
            {customers === null ? (
              <Loader active inline="centered" />
            ) : size(customers) === 0 ? (
              <p className="customer-picker__empty">
                {search ? "No se encontró ningún cliente." : "Todavía no hay clientes."}
              </p>
            ) : (
              map(customers, (customer) => (
                <div key={customer.id} className="customer-picker__item">
                  <button
                    type="button"
                    className="customer-picker__pick"
                    onClick={() => onSelect && onSelect(customer)}
                    disabled={!onSelect}
                  >
                    <Icon name={customer.kind === "COMPANY" ? "building" : "user"} />
                    <span>
                      <strong>{customer.full_name}</strong>
                      <small>
                        {customer.doc_number
                          ? `${customer.doc_type} ${customer.doc_number}`
                          : "Sin documento"}
                        {customer.phone && ` · ${customer.phone}`}
                      </small>
                    </span>
                  </button>
                  <Button basic size="small" onClick={() => setEditing(customer)}>
                    <Icon name="edit" /> Editar
                  </Button>
                </div>
              ))
            )}
          </>
        )}
      </Modal.Content>
    </Modal>
  );
}
